module.exports = __webpack_public_path__ + "img/hourglass-not-done.9d57b015.png";